function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
  fill: "#000000",
  stroke: "none"
}, /*#__PURE__*/React.createElement("path", {
  d: "M180 2765 c0 -1686 3 -2369 11 -2407 17 -80 74 -182 133 -234 186 -168 461 -162 630 15 112 119 126 173 126 503 l0 258 1658 2 1657 3 3 2108 2 2107 -2110 0 -2110 0 0 -2355z m3610 1150 l0 -605 -1505 0 -1505 0 0 605 0 605 1505 0 1505 0 0 -605z m-1500 -1055 l0 -150 -755 0 -755 0 0 150 0 150 755 0 755 0 0 -150z m1500 0 l0 -150 -600 0 -600 0 0 150 0 150 600 0 600 0 0 -150z m-1500 -600 l0 -150 -755 0 -755 0 0 150 0 150 755 0 755 0 0 -150z m1500 0 l0 -150 -600 0 -600 0 0 150 0 150 600 0 600 0 0 -150z m0 -600 l0 -150 -1505 0 -1505 0 0 150 0 150 1505 0 1505 0 0 -150z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1085 4207 c-3 -7 -4 -143 -3 -302 l3 -290 1203 -3 1202 -2 0 305 0 305 -1200 0 c-958 0 -1202 -3 -1205 -13z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1380 478 c0 -70 -7 -153 -15 -193 -15 -70 -67 -192 -105 -245 -11 -15 -20 -31 -20 -34 0 -4 672 -5 1493 -4 l1492 3 80 23 c275 80 503 273 609 514 l26 58 -1780 0 -1780 0 0 -122z"
}));
function SvgInfoSection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoSection);
export default __webpack_public_path__ + "static/media/info-section.9d40654fd4f89deb14bc8fc9ec3c1a83.svg";
export { ForwardRef as ReactComponent };